var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 381.895,
    height: 224,
    viewBox: "0 0 381.895 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-723.296 -97.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ghost",
    transform: "translate(814.831 97.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 100.419,
    cy: 100.384,
    rx: 100.419,
    ry: 100.384,
    fill: "#f6f8fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M339.262,325.6l-10.892-8.622a4.336,4.336,0,0,0-5.384,0l-15.223,12.055a4.338,4.338,0,0,1-5.384,0l-15.23-12.057a4.336,4.336,0,0,0-5.382,0l-15.232,12.057a4.336,4.336,0,0,1-5.383,0l-15.234-12.058a4.336,4.336,0,0,0-5.382,0l-10.9,8.627a4.336,4.336,0,0,1-7.027-3.4v-86.87a61.221,61.221,0,0,1,61.22-61.22h1.237a61.221,61.221,0,0,1,61.221,61.22V322.2A4.336,4.336,0,0,1,339.262,325.6Z",
    transform: "translate(-187.314 -153.99)",
    fill: "#2f8d46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(124.961 30.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M336.722,194.067a1.262,1.262,0,0,1-.789-.276,55.981,55.981,0,0,0-6.715-4.589,1.269,1.269,0,1,1,1.276-2.194,58.6,58.6,0,0,1,7.02,4.8,1.269,1.269,0,0,1-.792,2.262Z",
    transform: "translate(-328.587 -186.837)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(119.967 28.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M325.721,187.168a1.265,1.265,0,0,1-.565-.134q-.857-.425-1.729-.824a1.269,1.269,0,1,1,1.051-2.31q.914.416,1.81.862a1.269,1.269,0,0,1-.567,2.405Z",
    transform: "translate(-322.684 -183.786)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(96.485 23.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M314.825,183.455a1.259,1.259,0,0,1-.416-.071,55.311,55.311,0,0,0-18.208-3.062,1.269,1.269,0,0,1,0-2.538,57.859,57.859,0,0,1,19.041,3.2,1.27,1.27,0,0,1-.416,2.469Z",
    transform: "translate(-294.931 -177.784)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(38.579 16.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M234.15,318.322V231.452a61.222,61.222,0,0,1,58.01-61.137q-1.6-.082-3.211-.085h-1.237a61.221,61.221,0,0,0-61.221,61.221v86.869a4.337,4.337,0,0,0,7.028,3.4l1.318-1.044A4.283,4.283,0,0,1,234.15,318.322Z",
    transform: "translate(-226.49 -170.231)",
    fill: "#107028"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(71.493 60.043)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 13.673,
    height: 37.912,
    rx: 6.837,
    transform: "translate(1.269 1.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M273.566,261.773h-.137a8.046,8.046,0,0,1-8.037-8.038V229.361a8.046,8.046,0,0,1,8.037-8.038h.137a8.046,8.046,0,0,1,8.037,8.038v24.375A8.046,8.046,0,0,1,273.566,261.773Zm-.137-37.912a5.505,5.505,0,0,0-5.5,5.5v24.375a5.505,5.505,0,0,0,5.5,5.5h.137a5.505,5.505,0,0,0,5.5-5.5V229.361a5.505,5.505,0,0,0-5.5-5.5Z",
    transform: "translate(-265.392 -221.323)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6.215,
    height: 16.917,
    rx: 3.107,
    transform: "translate(76.491 71.808)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(113.134 60.043)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 13.673,
    height: 37.912,
    rx: 6.837,
    transform: "translate(1.269 1.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M322.782,261.773h-.137a8.046,8.046,0,0,1-8.037-8.038V229.361a8.046,8.046,0,0,1,8.037-8.038h.137a8.046,8.046,0,0,1,8.037,8.038v24.375A8.046,8.046,0,0,1,322.782,261.773Zm-.137-37.912a5.505,5.505,0,0,0-5.5,5.5v24.375a5.505,5.505,0,0,0,5.5,5.5h.137a5.505,5.505,0,0,0,5.5-5.5V229.361a5.505,5.505,0,0,0-5.5-5.5Z",
    transform: "translate(-314.608 -221.323)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 6.215,
    height: 16.917,
    rx: 3.107,
    transform: "translate(118.132 71.808)",
    fill: "#010001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M323.557,238.2a2.8,2.8,0,1,1-2.8-2.8A2.8,2.8,0,0,1,323.557,238.2Z",
    transform: "translate(-201.991 -163.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M273.954,238.2a2.8,2.8,0,1,1-2.8-2.8A2.8,2.8,0,0,1,273.954,238.2Z",
    transform: "translate(-194.356 -163.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(75.222 116.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M318.924,290.645H271.068a1.269,1.269,0,1,1,0-2.538h47.856a1.269,1.269,0,1,1,0,2.538Z",
    transform: "translate(-269.799 -288.107)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(37.31 103.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M226.259,277.349a1.269,1.269,0,0,1-1.269-1.269v-1.55a1.269,1.269,0,0,1,2.538,0v1.55A1.268,1.268,0,0,1,226.259,277.349Z",
    transform: "translate(-224.99 -273.261)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(37.31 15.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M267.493,327.134a5.594,5.594,0,0,1-3.478-1.215l-15.235-12.059a3.057,3.057,0,0,0-3.806,0l-10.9,8.626a5.605,5.605,0,0,1-9.084-4.4V265.826a1.269,1.269,0,1,1,2.538,0v52.265A3.068,3.068,0,0,0,232.5,320.5l10.9-8.626a5.587,5.587,0,0,1,6.957,0l15.235,12.059a3.056,3.056,0,0,0,3.806,0l15.233-12.057a5.58,5.58,0,0,1,6.957,0l15.229,12.056a3.056,3.056,0,0,0,3.807,0l15.224-12.055a5.581,5.581,0,0,1,6.958,0l10.892,8.622a3.067,3.067,0,0,0,4.971-2.405V231.221a60.02,60.02,0,0,0-59.951-59.952H287.48a60.02,60.02,0,0,0-59.952,59.952v20.107a1.269,1.269,0,1,1-2.538,0V231.221a62.561,62.561,0,0,1,62.49-62.49h1.237a62.561,62.561,0,0,1,62.49,62.49v86.868a5.6,5.6,0,0,1-9.084,4.4l-10.892-8.623a3.055,3.055,0,0,0-3.807,0L312.2,325.916a5.585,5.585,0,0,1-6.96,0L290.011,313.86a3.054,3.054,0,0,0-3.806,0l-15.233,12.057A5.59,5.59,0,0,1,267.493,327.134Z",
    transform: "translate(-224.99 -168.731)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(37.31 15.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M267.493,327.134a5.594,5.594,0,0,1-3.478-1.215l-15.235-12.059a3.057,3.057,0,0,0-3.806,0l-10.9,8.626a5.605,5.605,0,0,1-9.084-4.4V265.826a1.269,1.269,0,1,1,2.538,0v52.265A3.068,3.068,0,0,0,232.5,320.5l10.9-8.626a5.587,5.587,0,0,1,6.957,0l15.235,12.059a3.056,3.056,0,0,0,3.806,0l15.233-12.057a5.58,5.58,0,0,1,6.957,0l15.229,12.056a3.056,3.056,0,0,0,3.807,0l15.224-12.055a5.581,5.581,0,0,1,6.958,0l10.892,8.622a3.067,3.067,0,0,0,4.971-2.405V231.221a60.02,60.02,0,0,0-59.951-59.952H287.48a60.02,60.02,0,0,0-59.952,59.952v20.107a1.269,1.269,0,1,1-2.538,0V231.221a62.561,62.561,0,0,1,62.49-62.49h1.237a62.561,62.561,0,0,1,62.49,62.49v86.868a5.6,5.6,0,0,1-9.084,4.4l-10.892-8.623a3.055,3.055,0,0,0-3.807,0L312.2,325.916a5.585,5.585,0,0,1-6.96,0L290.011,313.86a3.054,3.054,0,0,0-3.806,0l-15.233,12.057A5.59,5.59,0,0,1,267.493,327.134Z",
    transform: "translate(-224.99 -168.731)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M236.376,165.629a4.65,4.65,0,1,1-4.65-4.65A4.65,4.65,0,0,1,236.376,165.629Z",
    transform: "translate(-188.001 -151.969)",
    fill: "#ffc829"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(37.805 7.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M231.5,171.317a5.919,5.919,0,0,1-4.509-9.754,1.269,1.269,0,1,1,1.932,1.645,3.382,3.382,0,1,0,2.576-1.19,1.269,1.269,0,1,1,0-2.538,5.919,5.919,0,0,1,0,11.838Z",
    transform: "translate(-225.575 -159.479)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M424.462,319.613a4.65,4.65,0,1,1-4.65-4.65A4.649,4.649,0,0,1,424.462,319.613Z",
    transform: "translate(-216.952 -175.716)",
    fill: "#ffc829"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(196.941 137.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M419.582,325.3a5.921,5.921,0,0,1-4.51-9.755,1.269,1.269,0,0,1,1.934,1.645,3.382,3.382,0,1,0,2.576-1.19,1.269,1.269,0,0,1,0-2.538,5.92,5.92,0,0,1,0,11.839Z",
    transform: "translate(-413.662 -313.463)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M220.919,194.942a4.65,4.65,0,1,1-4.651-4.651A4.651,4.651,0,0,1,220.919,194.942Z",
    transform: "translate(-185.622 -156.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(24.727 32.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M216.037,200.63a5.92,5.92,0,1,1,5.92-5.919A5.927,5.927,0,0,1,216.037,200.63Zm0-9.3a3.381,3.381,0,1,0,3.382,3.382A3.385,3.385,0,0,0,216.037,191.329Z",
    transform: "translate(-210.118 -188.791)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(19.796 12.188)",
    fill: "#44a6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(18.527 10.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M207.159,171.973a4.374,4.374,0,0,1-4.369-4.369,4.433,4.433,0,0,1,.074-.806,1.269,1.269,0,0,1,2.5.467,1.867,1.867,0,0,0-.031.339,1.831,1.831,0,1,0,1.831-1.831,1.809,1.809,0,0,0-.824.195,1.269,1.269,0,1,1-1.146-2.264,4.369,4.369,0,1,1,1.97,8.27Z",
    transform: "translate(-202.79 -163.235)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(179.748 133.05)",
    fill: "#44a6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(178.479 131.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M396.21,314.873a4.376,4.376,0,0,1-4.3-5.175,1.269,1.269,0,0,1,2.5.468,1.861,1.861,0,0,0-.03.338,1.831,1.831,0,1,0,1.831-1.831,1.791,1.791,0,0,0-.824.2,1.269,1.269,0,0,1-1.146-2.266,4.37,4.37,0,1,1,1.97,8.27Z",
    transform: "translate(-391.841 -306.135)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(7.307 51.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(6.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M198.342,217.4a1.268,1.268,0,0,1-1.269-1.269v-3.668a1.269,1.269,0,1,1,2.538,0v3.668A1.269,1.269,0,0,1,198.342,217.4Z",
    transform: "translate(-197.073 -211.197)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 6.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M194.466,221.279H190.8a1.269,1.269,0,0,1,0-2.538h3.668a1.269,1.269,0,1,1,0,2.538Z",
    transform: "translate(-189.529 -218.741)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(6.383 9.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M198.342,228.156a1.269,1.269,0,0,1-1.269-1.269v-3.669a1.269,1.269,0,1,1,2.538,0v3.669A1.27,1.27,0,0,1,198.342,228.156Z",
    transform: "translate(-197.073 -221.949)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(9.097 6.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M205.218,221.279H201.55a1.269,1.269,0,1,1,0-2.538h3.668a1.269,1.269,0,0,1,0,2.538Z",
    transform: "translate(-200.281 -218.741)",
    fill: "#010001"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(179.8 147.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(6.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M402.215,330.662a1.27,1.27,0,0,1-1.269-1.269v-3.668a1.269,1.269,0,1,1,2.538,0v3.668A1.27,1.27,0,0,1,402.215,330.662Z",
    transform: "translate(-400.946 -324.456)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 6.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M398.339,334.537h-3.668a1.269,1.269,0,0,1,0-2.538h3.668a1.269,1.269,0,1,1,0,2.538Z",
    transform: "translate(-393.402 -331.999)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(6.383 9.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M402.215,341.413a1.269,1.269,0,0,1-1.269-1.269v-3.667a1.269,1.269,0,0,1,2.538,0v3.667A1.269,1.269,0,0,1,402.215,341.413Z",
    transform: "translate(-400.946 -335.208)",
    fill: "#010001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(9.098 6.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M409.092,334.537h-3.668a1.269,1.269,0,1,1,0-2.538h3.668a1.269,1.269,0,0,1,0,2.538Z",
    transform: "translate(-404.155 -331.999)",
    fill: "#010001"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(39.394 175.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M228.3,406.259a.852.852,0,0,1-.845-.855c0-4.283,18.579-5.945,60.972-8.72,14.5-.948,29.487-1.929,40.674-3.124,16.811-1.8,18.573-3.455,18.713-3.922-.14-.435-1.9-2.094-18.714-3.89-11.189-1.195-26.178-2.175-40.676-3.124-42.391-2.773-60.969-4.436-60.969-8.719s18.578-5.941,60.969-8.713c14.5-.948,29.484-1.928,40.673-3.122,16.812-1.795,18.576-3.454,18.717-3.919a.839.839,0,0,1,.845-.838.852.852,0,0,1,.845.855c0,4.279-18.578,5.941-60.969,8.714-14.495.948-29.484,1.927-40.672,3.121-16.812,1.795-18.577,3.454-18.718,3.919.14.435,1.9,2.093,18.714,3.889,11.189,1.2,26.179,2.176,40.676,3.125,42.391,2.773,60.969,4.436,60.969,8.719s-18.577,5.945-60.967,8.718c-14.5.948-29.488,1.93-40.678,3.125-16.812,1.8-18.575,3.455-18.714,3.921A.839.839,0,0,1,228.3,406.259Z",
    transform: "translate(-227.453 -357.314)",
    fill: "#d0d2d6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404,
    transform: "translate(723.296 130.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M132.279,283.674H85.014c-6.729,0-12.309-4.923-12.309-11.652,0-5.252,2.133-9.355,5.907-13.786L128.5,200.3c4.759-5.58,8.369-8.534,15.755-8.534a11.978,11.978,0,0,1,12.145,11.98v59.41h6.072a10.3,10.3,0,0,1,10.34,10.341,10.158,10.158,0,0,1-10.34,10.174H156.4V297.46a11.979,11.979,0,0,1-12.145,11.981,11.84,11.84,0,0,1-11.98-11.981Zm0-20.515V227.383l-30.526,35.776Z",
    transform: "translate(-72.705 -190.5)",
    fill: "#ffc829"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(2.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M147.908,310.48a13.109,13.109,0,0,1-13.25-13.25V284.712h-46c-7.614,0-13.578-5.676-13.578-12.921,0-5.129,1.858-9.5,6.211-14.609l28.715-33.343a1.269,1.269,0,0,1,1.924,1.657L83.223,258.833c-3.977,4.669-5.6,8.424-5.6,12.958,0,5.822,4.85,10.383,11.04,10.383h47.266a1.269,1.269,0,0,1,1.269,1.269v13.786a10.794,10.794,0,0,0,21.587,0V283.443a1.269,1.269,0,0,1,1.269-1.269h6.072a8.893,8.893,0,0,0,9.07-8.9,9.081,9.081,0,0,0-9.07-9.072h-6.072a1.268,1.268,0,0,1-1.269-1.269V222.092a1.269,1.269,0,0,1,2.538,0v39.567h4.8a11.622,11.622,0,0,1,11.608,11.61,11.4,11.4,0,0,1-11.608,11.443h-4.8v12.517A13.191,13.191,0,0,1,147.908,310.48ZM135.928,264.2H105.4a1.269,1.269,0,0,1-.965-2.092l30.526-35.777a1.269,1.269,0,0,1,2.234.824v35.776A1.268,1.268,0,0,1,135.928,264.2Zm-27.775-2.538h26.506V230.595Zm4.666-37.868a1.27,1.27,0,0,1-.962-2.1l.426-.494a1.269,1.269,0,1,1,1.924,1.657l-.426.494A1.268,1.268,0,0,1,112.819,223.791Zm4.85-5.632a1.269,1.269,0,0,1-.961-2.1l14.483-16.817c5.076-5.951,9.058-8.975,16.718-8.975a13.19,13.19,0,0,1,13.414,13.25v11.645a1.269,1.269,0,1,1-2.538,0V203.519a10.679,10.679,0,0,0-10.875-10.711c-6.751,0-10.018,2.5-14.79,8.089l-14.487,16.822A1.265,1.265,0,0,1,117.669,218.159Z",
    transform: "translate(-75.084 -190.269)",
    fill: "#010001"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(276.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M458.652,283.674H411.387c-6.729,0-12.309-4.923-12.309-11.652,0-5.252,2.135-9.355,5.908-13.786L454.878,200.3c4.759-5.58,8.369-8.534,15.755-8.534a11.979,11.979,0,0,1,12.145,11.98v59.41h6.073A10.3,10.3,0,0,1,499.189,273.5a10.158,10.158,0,0,1-10.338,10.174h-6.073V297.46a11.979,11.979,0,0,1-12.145,11.981,11.841,11.841,0,0,1-11.981-11.981Zm0-20.515V227.383l-30.525,35.776Z",
    transform: "translate(-399.078 -190.5)",
    fill: "#ffc829"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(3.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M475.576,310.48a13.11,13.11,0,0,1-13.251-13.25V284.712h-46c-7.614,0-13.578-5.676-13.578-12.921,0-5.128,1.858-9.5,6.211-14.609L434.608,227.4a1.269,1.269,0,1,1,1.923,1.657l-25.641,29.773c-3.977,4.669-5.6,8.425-5.6,12.958,0,5.822,4.85,10.383,11.04,10.383h47.265a1.269,1.269,0,0,1,1.269,1.269v13.786a10.794,10.794,0,0,0,21.588,0V283.443a1.27,1.27,0,0,1,1.269-1.269h6.073a8.893,8.893,0,0,0,9.07-8.9,9.081,9.081,0,0,0-9.07-9.072H487.72a1.269,1.269,0,0,1-1.269-1.269V222.367a1.269,1.269,0,0,1,2.538,0v39.293h4.8a11.622,11.622,0,0,1,11.608,11.61,11.4,11.4,0,0,1-11.608,11.443h-4.8v12.517A13.191,13.191,0,0,1,475.576,310.48ZM463.594,264.2H433.069a1.268,1.268,0,0,1-.965-2.092l30.526-35.777a1.269,1.269,0,0,1,2.234.824v35.776A1.268,1.268,0,0,1,463.594,264.2Zm-27.774-2.538h26.505V230.595Zm2.73-35.621a1.269,1.269,0,0,1-.961-2.1l21.27-24.7c5.076-5.951,9.057-8.975,16.718-8.975a13.19,13.19,0,0,1,13.413,13.25v7.632a1.269,1.269,0,1,1-2.538,0v-7.632a10.679,10.679,0,0,0-10.875-10.711c-6.752,0-10.019,2.5-14.79,8.089l-21.273,24.7A1.266,1.266,0,0,1,438.55,226.039Zm49.17-5.96a1.269,1.269,0,0,1-1.269-1.269v-1.231a1.269,1.269,0,0,1,2.538,0v1.231A1.269,1.269,0,0,1,487.72,220.079Z",
    transform: "translate(-402.751 -190.269)",
    fill: "#010001"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.2760f1a73656407b3777a4342f550c3c.svg";
export { ForwardRef as ReactComponent };